window["IdInputWithCocoon"] = (function () {
  // 具体的な使い方は `/system/project/:id/edit` の特定用途のトピックの部分を参照して下さい。

  const FetchStatus = {
    FETCHING: -1,
    FREE: 0,
    SUCCESS: 1,
    ERROR: 2,
  };
  const FETCH_ID_TIMEOUT = 10000;
  const ATTR_DATA_INPUT_ID = "data-input-id";

  async function fetchNameFrom(baseUrl, id) {
    id = parseInt(id);
    if (!(id > 0)) return null;

    const controller = new AbortController();
    let needAbort = true;

    setTimeout(() => {
      if (!needAbort) return;
      controller.abort();
    }, FETCH_ID_TIMEOUT);

    const response = await fetch(`${baseUrl}/${id}.json`, {
      signal: controller.signal,
    });

    needAbort = false;

    if (!response.ok) return null;

    const json = await response.json();
    return json && json.name;
  }

  return class IdInputWithCocoon {
    /**
     * new IdInputWithCocoon のラッパー
     * 具体的な使い方は `/system/project/:id/edit` の特定用途のトピックの部分を参照して下さい。
     * (実装時点では app/views/shared/projects/_form.html.erb#project-specific-topics になります)
     * @param {Object} opt - 引数オブジェクト
     * @param {string} opt.cocoon - Cocoonのベースになる要素を特定するセレクタ
     * @param {string} opt.input - ID入力欄を特定するセレクタ
     * @param {string} opt.preview - IDから取得したオブジェクトのnameをプレビュー表示する要素を特定するセレクタ
     * @param {string} opt.fieldId - _*_fields.html.erb でのIDを設定するinput[type=hidden}要素を特定するセレクタ
     * @param {string} opt.fieldName - _*_fields.html.erb でのnameを表示する要素を特定するセレクタ
     * @param {string} opt.baseUrl - IDからオブジェクトを取得する為の基準URL(末尾のスラッシュは不要です)
     */
    static register(opt) {
      new IdInputWithCocoon(opt);
    }

    constructor({ cocoon, input, preview, fieldId, fieldName, baseUrl }) {
      this.status = FetchStatus.FREE;
      this.baseUrl = baseUrl;

      this.idSucceeded = null;
      this.fetchedName = null;
      this.idWaiting = null;

      this.$input = $(input);
      this.$preview = $(preview);
      this.$cocoon = $(cocoon);
      this.$parent = this.$cocoon.parent();

      this.$input
        .on("input", async (event) => {
          this.processInput(event.target.value);
        })
        .on("keydown", (event) => {
          if (event.key == "Enter") event.preventDefault();
        });

      this.$cocoon
        .on("cocoon:before-insert", (event, fields) => {
          if (this.status != FetchStatus.SUCCESS) {
            event.preventDefault();
            return;
          }
          fields.find(fieldId).val(this.idSucceeded);
          fields.find(fieldName).attr("value", this.fetchedName);
          fields.attr(ATTR_DATA_INPUT_ID, this.idSucceeded);
          this.$input.val("");
          this.$preview.text("");
        })
        .on("cocoon:after-remove", (event, fields) => {
          fields.removeAttr(ATTR_DATA_INPUT_ID);
        });
    }

    processWaitingInputId() {
      if (this.idWaiting === null) return;

      const id = this.idWaiting;
      this.idWaiting = null;

      this.processInput(id);
    }

    async processInput(id) {
      if (this.status == FetchStatus.FETCHING) {
        this.idWaiting = id;
        return;
      }

      this.status = FetchStatus.FETCHING;
      this.$preview.text("(取得中)");

      try {
        const name = await fetchNameFrom(this.baseUrl, id);

        if (name === null) {
          this.status = FetchStatus.FREE;
          this.$preview.text("(無効なIDです)");
          this.processWaitingInputId();
          return;
        }

        if (this.$parent.find(`[${ATTR_DATA_INPUT_ID}='${id}']`).length) {
          this.status = FetchStatus.FREE;
          this.$preview.text(`(IDは指定済みです:${name})`);
          this.processWaitingInputId();
          return;
        }

        this.status = FetchStatus.SUCCESS;
        this.idSucceeded = id;
        this.fetchedName = name;

        this.$preview.text(this.fetchedName);

        this.processWaitingInputId();
      } catch (e) {
        this.$preview.text("(エラー)");
        /* eslint-disable-next-line no-console */
        console.error(e);
        this.status = FetchStatus.ERROR;

        this.processWaitingInputId();
      }
    }
  };
})();
